import { classnames } from 'Utils/classnames/classnames.utils';

export const sizes = {
  auto: 'w-auto',
  small: 'w-380',
  medium: 'w-640',
  large: 'w-800',
};

type ThemeSizeArg = { size?: keyof typeof sizes };

export const themes = ({ size = 'medium' }: ThemeSizeArg = {}) => ({
  default: {
    thRoot: classnames(
      'animation-duration-500 relative isolate flex max-h-[70vh] min-h-100 max-w-full animate-fadeIn animate-scaleIn',
      sizes[size],
    ),
    thCloseButton:
      'absolute bg-white border-1 cursor-pointer leading-0 top-0 mb-10 end-0 p-5 rounded-full z-2 top-auto bottom-full size-40',
    thCloseButtonLabel: 'sr-only',
    thCloseIconWidth: '1rem',
    thBody:
      'bg-white max-h-full relative z-1 overflow-hidden rounded-12 shadow w-full flex flex-col max-h-[70vh]',
    thContent: 'isolate max-h-full overflow-auto relative w-full',
    thAddendum:
      'max-h-full fixed bottom-0 inset-x-0 overflow-hidden rounded-4 md:rounded-2 shadow w-full max-h-[70vh]',
    thAddendumContent: 'max-h-full overflow-auto relative w-full',
  },
});
